import React, { useState, useEffect } from "react";
import {
  FormControl,
  Select,
  MenuItem,
  Card,
  CardContent,
} from "@material-ui/core";
import 'leaflet/dist/leaflet.css'

import "./App.css";
import InfoBox from "./InfoBox";
import Map from "./Map";
import Table from "./Table";
import LineGraph from "./LineGraph";
import { sortData, prettyPrintStat } from './util'

function App() {
  //states
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState(["worldwide"]);
  const [countryInfo, setCountryInfo] = useState({});
  const [tableData, setTableData] = useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: 34.80746, lng: -40.4796});
  const [mapZoom, setMapZoom] = useState(3);
  const [mapCountries, setMapCountries] = useState([]);
  const [casesType, setCasesType] = useState('cases')

  // => onload fetch worldwide data
  useEffect(() => {
    const getWorlwideData = async () => {
      const response = await fetch("https://disease.sh/v3/covid-19/all");
      const resData = await response.json();
      setCountryInfo(resData);
    };
    getWorlwideData();
  }, []);

  // => onload fetch all countries for dropdown
  useEffect(() => {
    const getCountriesData = async () => {
      const response = await fetch("https://disease.sh/v3/covid-19/countries");
      const resData = await response.json();
      const _countries = resData.map((country) => ({
        name: country.country,
        value: country.countryInfo.iso2,
      }));
      //tableData => all countries (All Data)
      const sortedData = sortData(resData);
      setTableData(sortedData);

      //for dropdown
      setCountries(_countries);

      //for map
      setMapCountries(resData);
    };
    getCountriesData();
  }, []);

  //handlers
  // => whenever the country change, update the dropdown and fetch new country data
  const countryChangeHandler = async (e) => {
    const countryCode = e.target.value;
    setCountry(countryCode);

    // => when user selects a new country, fetch new data
    const url =
      countryCode === "worldwide"
        ? "https://disease.sh/v3/covid-19/all"
        : `https://disease.sh/v3/covid-19/countries/${countryCode}?strict=true`;

    const response = await fetch(url);
    const resData = await response.json();
    setCountry(countryCode);
    setCountryInfo(resData);

    setMapCenter({lat: [resData.countryInfo.lat], lng: [resData.countryInfo.long]});
    setMapZoom(3)
  };

  return (
    <div className="app">
      <div className="app__left">
        {/* header */}
        <div className="app__header">
          <h1>Covid 19 Tracker</h1>
          <FormControl className="app__dropdown">
            <Select
              variant="outlined"
              value={country}
              onChange={countryChangeHandler}
            >
              <MenuItem value="worldwide">Worldwide</MenuItem>
              {countries.map((country) => (
                <MenuItem
                  key={Math.random() * Math.random()}
                  value={country.value}
                >
                  {country.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        {/* Header Done */}

        {/* infobox 3 */}
        <div className="app__stats">
          <InfoBox
            title="coronavirus Cases"
            cases={prettyPrintStat(countryInfo.todayCases)}
            total={prettyPrintStat(countryInfo.cases)}
            onClick={e=> setCasesType('cases')}
            active={casesType === 'cases'}
            color='red'
          />
          <InfoBox
            title="Recovered"
            cases={prettyPrintStat(countryInfo.todayRecovered)}
            total={prettyPrintStat(countryInfo.recovered)}
            onClick={e=> setCasesType('recovered')}
            active={casesType === 'recovered'}
            color='greenyellow'
          />
          <InfoBox
            title="Deaths"
            cases={prettyPrintStat(countryInfo.todayDeaths)}
            total={prettyPrintStat(countryInfo.deaths)}
            onClick={e=> setCasesType('deaths')}
            active={casesType === 'deaths'}
            color='red'
          />
        </div>
        {/* infobox 3 done */}

        {/* map */}
        <Map center={mapCenter} zoom={mapZoom} countries={mapCountries} casesType={casesType} />
      </div>

      <Card className="app__right">
        <CardContent>
          <h3>Live cases by Country</h3>
          {/* table */}
          <Table countries={tableData} />
          <h3>Worldwide new {casesType}</h3>
          {/* graph */}
          <LineGraph casesType={casesType} />
        </CardContent>
      </Card>
    </div>
  );
}

export default App;
